import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { PaginatedTeamMembers } from '../../../../interfaces/teams/paginatedStore.type';

const tryToFetchTeamMembers = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<PaginatedTeamMembers>> => {
    const url = filters
        ? `${USERS_API_URL}/rebecca-users/users/by-company?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/rebecca-users/users/by-company?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.put<PaginatedTeamMembers>(url, data);
};

const tryToFetchAllTeamMembers = (data: any): Promise<AxiosResponse<any>> => {
    const url = data?.filters ?
        `${USERS_API_URL}/rebecca-users/users/by-company/all?search=${data?.filters}`
        : `${USERS_API_URL}/rebecca-users/users/by-company/all`
    return brokersAxios.put(url, data?.data);
};

const tryToFetchSingleTeamMember = (id: string): Promise<AxiosResponse<any>> => {
    return brokersAxios.get(`${USERS_API_URL}/rebecca-users/users/by-company/${id}`);
};

const tryToUpdateTeamMemberRole = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/rebecca-users/users/update-role`, data);
};

const tryToDeleteTeamMembers = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/rebecca-users/users/by-company/offboard-users`, data);
};

const tryToChangeTeamMembersStatus = (status: string, data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.put(`${USERS_API_URL}/rebecca-users/users/status/${status}`, data);
};

const tryToCreateNewUser = (data: any): Promise<AxiosResponse<any>> => {
    return brokersAxios.post(`${USERS_API_URL}/rebecca-users/users/new-user`, data);
};


export const TeamsService = {
    tryToFetchTeamMembers,
    tryToFetchAllTeamMembers,
    tryToFetchSingleTeamMember,
    tryToDeleteTeamMembers,
    tryToUpdateTeamMemberRole,
    tryToChangeTeamMembersStatus,
    tryToCreateNewUser
};